//
// HiddenSection.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./Section";
import "./HiddenSectionPurpose";
import "@sas-dvr/ltjs-commons/util/Dimension";

var HiddenSection = createModule("BIRD::HiddenSection", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::Section"], EventDispatcher, [
    ,
    {
        purpose: 4,
        width: 1,
        height: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default HiddenSection;
